const candidate = {
  namespaced: true,
  state: {
    application: {
      Id: null,
      userinfo: {
        Candidate_name: "",
        Father_Husband_Name: "",
        DOB: "",
        Present_Address1: "",
        Present_Address2: "",
        Present_Address3: "",
        Present_pincode: null,
        Present_City: "",
        Present_State: "",
        Permanent_Address1: "",
        Permanent_Address2: "",
        Permanent_Address3: "",
        Permanent_pincode: null,
        Permanent_City: "",
        Permanent_State: "",
        Candidate_mobileno: null,
        Marital_status: "",
      },
      education: [],
      employeerecord: [],
      languages: [],
      expectation: {
        Present_salary: "",
        Expected_Salary: "",
        Height: "",
        Weight: "",
        Other: "",
      },
    },
  },
  mutations: {
    updateId(state) {
      state.application.Id = sessionStorage.getItem("id");
    },
    updateName(state, Candidate_name) {
      state.application.userinfo.Candidate_name = Candidate_name;
    },
    updatefhname(state, Father_Husband_Name) {
      state.application.userinfo.Father_Husband_Name = Father_Husband_Name;
    },
    updatedob(state, DOB) {
      state.application.userinfo.DOB = DOB;
    },
    updateaddress1(state, Present_Address1) {
      state.application.userinfo.Present_Address1 = Present_Address1;
    },
    updateaddress2(state, Present_Address2) {
      state.application.userinfo.Present_Address2 = Present_Address2;
    },
    updateaddress3(state, Present_Address3) {
      state.application.userinfo.Present_Address3 = Present_Address3;
    },
    updatepincode(state, Present_pincode) {
      state.application.userinfo.Present_pincode = Present_pincode;
    },
    updatecity(state, Present_City) {
      state.application.userinfo.Present_City = Present_City;
    },
    updatestates(state, Present_State) {
      state.application.userinfo.Present_State = Present_State;
    },
    updatePermanentAddress1(state, Permanent_Address1) {
      state.application.userinfo.Permanent_Address1 = Permanent_Address1;
    },
    updatePermanentAddress2(state, Permanent_Address2) {
      state.application.userinfo.Permanent_Address2 = Permanent_Address2;
    },
    updatePermanentAddress3(state, Permanent_Address3) {
      state.application.userinfo.Permanent_Address3 = Permanent_Address3;
    },
    updatePermanentPincode(state, Permanent_pincode) {
      state.application.userinfo.Permanent_pincode = Permanent_pincode;
    },
    updatePermanentCity(state, Permanent_City) {
      state.application.userinfo.Permanent_City = Permanent_City;
    },
    updatePermanentStates(state, Permanent_State) {
      state.application.userinfo.Permanent_State = Permanent_State;
    },
    updatemobno(state, Candidate_mobileno) {
      state.application.userinfo.Candidate_mobileno = Candidate_mobileno;
    },
    updateMaritalstatus(state, Marital_status) {
      state.application.userinfo.Marital_status = Marital_status;
    },
    addEdu(state, edudetails) {
      state.application.education.push(edudetails);
    },
    removeEdu(state, values) {
      state.application.education.pop(values);
    },
    deleteEdu(state) {
      state.application.education = [];
    },
    addEmp(state, employeerecord) {
      state.application.employeerecord.push(employeerecord);
    },
    removeEmp(state, values) {
      state.application.employeerecord.pop(values);
    },
    deleteEmp(state) {
      state.application.employeerecord = [];
    },
    addLang(state, languages) {
      state.application.languages.push(languages);
    },
    removeLang(state, values) {
      state.application.languages.pop(values);
    },
    deleteLang(state) {
      state.application.languages = [];
    },
    updatePresentSalary(state, PresentSalary) {
      state.application.expectation.Present_salary = PresentSalary;
    },
    updateExpextedSalary(state, ExpextedSalary) {
      state.application.expectation.Expected_Salary = ExpextedSalary;
    },
    updateHeightincms(state, Heightincms) {
      state.application.expectation.Height = Heightincms;
    },
    updateWeightinkg(state, Weightinkg) {
      state.application.expectation.Weight = Weightinkg;
    },
    updatedisability(state, disability) {
      state.application.expectation.Other = disability;
    },
  },
  actions: {
    addLang({ commit }, languages) {
      commit("addLang", languages);
    },
    removeLang({ commit }, languages) {
      commit("removeLang", languages);
    },
    addEmp({ commit }, employeerecord) {
      commit("addEmp", employeerecord);
    },
    removeEmp({ commit }, employeerecord) {
      commit("removeEmp", employeerecord);
    },
    updateName({ commit }, Candidate_name) {
      commit("updateName", Candidate_name);
    },
    updatefhname({ commit }, Father_Husband_Name) {
      commit("updatefhname", Father_Husband_Name);
    },
    updatedob({ commit }, DOB) {
      commit("updatedob", DOB);
    },
    updateaddress1({ commit }, Present_Address1) {
      commit("updateaddress1", Present_Address1);
    },
    updateaddress2({ commit }, Present_Address2) {
      commit("updateaddress2", Present_Address2);
    },
    updateaddress3({ commit }, Present_Address3) {
      commit("updateaddress3", Present_Address3);
    },
    updatepincode({ commit }, Present_pincode) {
      commit("updatepincode", Present_pincode);
    },
    updatecity({ commit }, Present_City) {
      commit("updatecity", Present_City);
    },
    updatestates({ commit }, Present_State) {
      commit("updatestates", Present_State);
    },
    updatePaddress1({ commit }, Permanent_Address1) {
      commit("updatePermanentAddress1", Permanent_Address1);
    },
    updatePaddress2({ commit }, Permanent_Address2) {
      commit("updatePermanentAddress2", Permanent_Address2);
    },
    updatePaddress3({ commit }, Permanent_Address3) {
      commit("updatePermanentAddress3", Permanent_Address3);
    },
    updatepincode2({ commit }, Permanent_pincode) {
      commit("updatePermanentPincode", Permanent_pincode);
    },
    updatecity2({ commit }, Permanent_City) {
      commit("updatePermanentCity", Permanent_City);
    },
    updatestates2({ commit }, Permanent_State) {
      commit("updatePermanentStates", Permanent_State);
    },
    updatemobno({ commit }, Candidate_mobileno) {
      commit("updatemobno", Candidate_mobileno);
    },
    updateMaritalstatus({ commit }, Marital_status) {
      commit("updateMaritalstatus", Marital_status);
    },
    updatePresentSalary({ commit }, PresentSalary) {
      commit("updatePresentSalary", PresentSalary);
    },
    updateExpextedSalary({ commit }, ExpextedSalary) {
      commit("updateExpextedSalary", ExpextedSalary);
    },
    updateHeightincms({ commit }, Heightincms) {
      commit("updateHeightincms", Heightincms);
    },
    updateWeightinkg({ commit }, Weightinkg) {
      commit("updateWeightinkg", Weightinkg);
    },
    updatedisability({ commit }, disability) {
      commit("updatedisability", disability);
    },
  },
};

export default candidate;
